const transformCustomOptions = (custom_options)=>custom_options?.map(({ option_id , option_value  })=>({
            id: isNaN(option_id) ? option_id : parseInt(option_id),
            value: isNaN(option_value) ? option_value : parseInt(option_value)
        })) || [];
const transformCustomOptionsRequest = (custom_options)=>custom_options?.map(({ id , value  })=>({
            option_id: id,
            option_value: Array.isArray(value) ? value.join(',') : value.toString()
        })) || null;

export { transformCustomOptions, transformCustomOptionsRequest };
